<template>
  <div class="plans-filters">
    <PlansFilterRooms :rooms-filter="roomsFilter" />
    <PlansFilterPrice :flats="flats" />
    <PlansFilterArea :flats="flats" />
    <PlansFilterFloor :flats="flats" />
    <PlansFilterFeatures :flats="flats" />
    <PlansFilterSort />
  </div>
</template>

<script>
import PlansFilterRooms from "@/components/home/filters/PlansFilterRooms.vue";
import PlansFilterPrice from "@/components/home/filters/PlansFilterPrice.vue";
import PlansFilterArea from "@/components/home/filters/PlansFilterArea.vue";
import PlansFilterFloor from "@/components/home/filters/PlansFilterFloor.vue";
import PlansFilterFeatures from "@/components/home/filters/PlansFilterFeatures.vue";
import PlansFilterSort from "@/components/home/filters/PlansFilterSort.vue";
export default {
  components: {
    PlansFilterRooms,
    PlansFilterPrice,
    PlansFilterArea,
    PlansFilterFloor,
    PlansFilterFeatures,
    PlansFilterSort,
  },
  props: {
    roomsFilter: {
      type: Array,
      default: () => [],
    },
    flats: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  margin-bottom: 80px;
}

.plans-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 45px 83px;
  align-items: flex-start;
  margin-bottom: 48px;
}
@media (max-width: 1280px) {
  .plans-filters {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 992px) {
  .plans-filters {
    gap: 25px 15px;
  }
}
@media (max-width: 576px) {
  .plans-filters {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 30px;
  }

  .plans-filter-rooms {
    grid-column: 1 / 3;
  }

  .plans-filter-sort {
    grid-column: 1 / 3;
  }

  .plans-filter-floor {
    grid-column: 1 / 3;
  }

  .plans-filters:has(.plans-filter-features) .plans-filter-floor {
    grid-column: auto;
  }
}
</style>
